import { useState, useEffect } from "react";
import moment from "moment";

export const useDependenteForm = (form) => {
  const [modo, setModo] = useState("lista");
  const [dependente, setDependente] = useState(null);

  const carregarDependente = (dependenteSelecionado) => {
    setDependente(dependenteSelecionado);
    setModo("identificacao");
  };

  const criarNovoDependente = (novo) => {
    form.resetFields();
    if (novo) {
    form.setFieldsValue({
      dependente: novo,
    });
  }
    setDependente(novo);
    setModo("identificacao");
  };

  /*useEffect(() => {
    if (modo === "identificacao" && dependente) {
      const p = dependente.pessoa;
      const e = dependente.endereco;
      const c = dependente.contato
        ? {
            ...dependente.contato,
            telefone1: formatarTelefone(dependente.contato.telefone1),
            telefoneContato: formatarTelefone(
              dependente.contato.telefoneContato
            ),
          }
        : {};
      const dependenteCorrigido = {
        ...dependente,
        motivoFimDependencia:
          dependente.motivoFimDependencia === 0
            ? undefined
            : dependente.motivoFimDependencia,
        dataInicio: dependente.dataInicio
          ? moment(dependente.dataInicio)
          : null,
        dataFimPrevista: dependente.dataFimPrevista
          ? moment(dependente.dataFimPrevista)
          : null,
        dataFim: dependente.dataFim ? moment(dependente.dataFim) : null,
        pessoa: {
          ...p,
          expedicaoPassaporte: p.expedicaoPassaporte
            ? moment(p.expedicaoPassaporte)
            : null,
          validadePassaporte: p.validadePassaporte
            ? moment(p.validadePassaporte)
            : null,
          expedicaoCarteiraProfissional: p.expedicaoCarteiraProfissional
            ? moment(p.expedicaoCarteiraProfissional)
            : null,
          validadeCarteiraProfissional: p.validadeCarteiraProfissional
            ? moment(p.validadeCarteiraProfissional)
            : null,
          expedicaoIdentidade: p.expedicaoIdentidade
            ? moment(p.expedicaoIdentidade)
            : null,
          dataDeNascimento: p.dataDeNascimento
            ? moment(p.dataDeNascimento)
            : null,
          validadeHabilit: p.validadeHabilit ? moment(p.validadeHabilit) : null,
          emissaoHabilit: p.emissaoHabilit ? moment(p.emissaoHabilit) : null,
        },
        endereco: e || {},
        contato: c || {},
      };

      form.setFieldsValue({
        dependente: dependenteCorrigido,
      });
    }
  }, [modo, dependente]);*/

  useEffect(() => {
  if (modo === "identificacao" && dependente) {
    const p = dependente.pessoa || {};
    const e = dependente.endereco || {};

    const c = dependente.contato
      ? {
          ...dependente.contato,
          telefone1: formatarTelefone(
            dependente.contato.telefone1
          ),
          telefoneContato: formatarTelefone(
            dependente.contato.telefoneContato
          ),
        }
      : {};

    const dependenteCorrigido = {
      ...dependente,

      motivoFimDependencia:
        dependente.motivoFimDependencia === 0
          ? undefined
          : dependente.motivoFimDependencia,

      dataInicio: dependente.dataInicio
        ? moment(dependente.dataInicio)
        : null,

      dataFimPrevista: dependente.dataFimPrevista
        ? moment(dependente.dataFimPrevista)
        : null,

      dataFim: dependente.dataFim
        ? moment(dependente.dataFim)
        : null,

      pessoa: {
        ...p,

        expedicaoPassaporte: p.expedicaoPassaporte
          ? moment(p.expedicaoPassaporte)
          : null,

        validadePassaporte: p.validadePassaporte
          ? moment(p.validadePassaporte)
          : null,

        expedicaoCarteiraProfissional:
          p.expedicaoCarteiraProfissional
            ? moment(p.expedicaoCarteiraProfissional)
            : null,

        validadeCarteiraProfissional:
          p.validadeCarteiraProfissional
            ? moment(p.validadeCarteiraProfissional)
            : null,

        expedicaoIdentidade: p.expedicaoIdentidade
          ? moment(p.expedicaoIdentidade)
          : null,

        dataDeNascimento: p.dataDeNascimento
          ? moment(p.dataDeNascimento)
          : null,

        validadeHabilit: p.validadeHabilit
          ? moment(p.validadeHabilit)
          : null,

        emissaoHabilit: p.emissaoHabilit
          ? moment(p.emissaoHabilit)
          : null,
      },

      endereco: e,
      contato: c,
    };

    form.setFieldsValue({
      dependente: dependenteCorrigido,
    });
  }
}, [modo, dependente]);


  const formatarTelefone = (valor) => {
    if (!valor) return valor;

    const numeros = valor.replace(/\D/g, "");

    if (numeros.length === 11) {
      return numeros.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }

    if (numeros.length === 10) {
      return numeros.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }

    return valor;
  };

  return {
    modo,
    setModo,
    dependente,
    carregarDependente,
    criarNovoDependente,
  };
};
